/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const listUserLoginActivities = /* GraphQL */ `
  query ListUserLoginActivities {
    listUserLoginActivities {
      userID
      username
      email
      lastLoginAt
      previousLoginAt
      loginCount
      createdAt
      updatedAt
    }
  }
`;
export const getPricingPageContent = /* GraphQL */ `
  query GetPricingPageContent($id: ID!) {
    getPricingPageContent(id: $id) {
      id
      heroTitle
      heroDescription
      eyebrow
      heading
      introduction
      monthlyName
      monthlyDescription
      monthlyEquivalent
      monthlyBadge
      monthlyFeatures
      monthlyCta
      yearlyName
      yearlyDescription
      yearlyEquivalent
      yearlyBadge
      yearlyFeatures
      yearlyCta
      assurances
      noticeTitle
      noticeBody
      createdAt
      updatedAt
    }
  }
`;
export const listPricingPageContents = /* GraphQL */ `
  query ListPricingPageContents(
    $filter: ModelPricingPageContentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listPricingPageContents(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        heroTitle
        heroDescription
        eyebrow
        heading
        introduction
        monthlyName
        monthlyDescription
        monthlyEquivalent
        monthlyBadge
        monthlyFeatures
        monthlyCta
        yearlyName
        yearlyDescription
        yearlyEquivalent
        yearlyBadge
        yearlyFeatures
        yearlyCta
        assurances
        noticeTitle
        noticeBody
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getNotice = /* GraphQL */ `
  query GetNotice($id: ID!) {
    getNotice(id: $id) {
      id
      title
      content
      attachments
      date
      status
      deliveryTarget
      externalLink
      externalLinkLabel
      expiresAt
      isImportant
      createdAt
      updatedAt
    }
  }
`;
export const listNotices = /* GraphQL */ `
  query ListNotices(
    $filter: ModelNoticeFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listNotices(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        title
        content
        attachments
        date
        status
        deliveryTarget
        externalLink
        externalLinkLabel
        expiresAt
        isImportant
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getFeedback = /* GraphQL */ `
  query GetFeedback($id: ID!) {
    getFeedback(id: $id) {
      id
      type
      clarity
      videoQuality
      referralLikelihood
      difficulty
      mood
      improvement
      requestedMove
      audio
      createdAt
      updatedAt
      username
      owner
    }
  }
`;
export const listFeedbacks = /* GraphQL */ `
  query ListFeedbacks(
    $filter: ModelFeedbackFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listFeedbacks(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        type
        clarity
        videoQuality
        referralLikelihood
        difficulty
        mood
        improvement
        requestedMove
        audio
        createdAt
        updatedAt
        username
        owner
      }
      nextToken
    }
  }
`;
export const getUserProfile = /* GraphQL */ `
  query GetUserProfile($id: ID!) {
    getUserProfile(id: $id) {
      id
      username
      displayName
      phoneNumber
      profileImageKey
      bio
      city
      instagramHandle
      onboardingCompleted
      country
      danceLevel
      danceExperienceYears
      danceExperienceMonths
      favoriteStyles
      trainingFrequency
      goals
      howHeardAboutUs
      createdAt
      updatedAt
      owner
    }
  }
`;
export const listUserProfiles = /* GraphQL */ `
  query ListUserProfiles(
    $filter: ModelUserProfileFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUserProfiles(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        username
        displayName
        phoneNumber
        profileImageKey
        bio
        city
        instagramHandle
        onboardingCompleted
        country
        danceLevel
        danceExperienceYears
        danceExperienceMonths
        favoriteStyles
        trainingFrequency
        goals
        howHeardAboutUs
        createdAt
        updatedAt
        owner
      }
      nextToken
    }
  }
`;
export const getMemberAccess = /* GraphQL */ `
  query GetMemberAccess($id: ID!) {
    getMemberAccess(id: $id) {
      id
      userID
      status
      scope
      startsAt
      expiresAt
      reason
      grantedBy
      grantedAt
      revokedAt
      createdAt
      updatedAt
    }
  }
`;
export const listMemberAccesses = /* GraphQL */ `
  query ListMemberAccesses(
    $filter: ModelMemberAccessFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listMemberAccesses(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        userID
        status
        scope
        startsAt
        expiresAt
        reason
        grantedBy
        grantedAt
        revokedAt
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getShowSeries = /* GraphQL */ `
  query GetShowSeries($id: ID!) {
    getShowSeries(id: $id) {
      id
      title
      slug
      description
      coverImageUrl
      bannerImageUrl
      category
      externalUrl
      externalLinkLabel
      isFeatured
      status
      sortOrder
      createdAt
      updatedAt
    }
  }
`;
export const listShowSeries = /* GraphQL */ `
  query ListShowSeries(
    $filter: ModelShowSeriesFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listShowSeries(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        title
        slug
        description
        coverImageUrl
        bannerImageUrl
        category
        externalUrl
        externalLinkLabel
        isFeatured
        status
        sortOrder
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getShowEpisode = /* GraphQL */ `
  query GetShowEpisode($id: ID!) {
    getShowEpisode(id: $id) {
      id
      seriesID
      title
      description
      videoUrl
      videoProvider
      thumbnailUrl
      seasonNumber
      episodeNumber
      durationLabel
      releaseDate
      status
      sortOrder
      createdAt
      updatedAt
    }
  }
`;
export const listShowEpisodes = /* GraphQL */ `
  query ListShowEpisodes(
    $filter: ModelShowEpisodeFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listShowEpisodes(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        seriesID
        title
        description
        videoUrl
        videoProvider
        thumbnailUrl
        seasonNumber
        episodeNumber
        durationLabel
        releaseDate
        status
        sortOrder
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getInstructor = /* GraphQL */ `
  query GetInstructor($id: ID!) {
    getInstructor(id: $id) {
      id
      name
      slug
      bio
      country
      styles
      profileImageUrl
      headerImageUrl
      instagramUrl
      youtubeUrl
      websiteUrl
      isFeatured
      status
      sortOrder
      createdAt
      updatedAt
    }
  }
`;
export const listInstructors = /* GraphQL */ `
  query ListInstructors(
    $filter: ModelInstructorFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listInstructors(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        slug
        bio
        country
        styles
        profileImageUrl
        headerImageUrl
        instagramUrl
        youtubeUrl
        websiteUrl
        isFeatured
        status
        sortOrder
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getCourse = /* GraphQL */ `
  query GetCourse($id: ID!) {
    getCourse(id: $id) {
      id
      title
      slug
      shortDescription
      description
      coverImageUrl
      trailerUrl
      difficulty
      accessLevel
      tags
      instructorIDs
      isFeatured
      status
      sortOrder
      createdAt
      updatedAt
    }
  }
`;
export const listCourses = /* GraphQL */ `
  query ListCourses(
    $filter: ModelCourseFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCourses(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        title
        slug
        shortDescription
        description
        coverImageUrl
        trailerUrl
        difficulty
        accessLevel
        tags
        instructorIDs
        isFeatured
        status
        sortOrder
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getCourseModule = /* GraphQL */ `
  query GetCourseModule($id: ID!) {
    getCourseModule(id: $id) {
      id
      courseID
      title
      description
      status
      sortOrder
      createdAt
      updatedAt
    }
  }
`;
export const listCourseModules = /* GraphQL */ `
  query ListCourseModules(
    $filter: ModelCourseModuleFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCourseModules(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        courseID
        title
        description
        status
        sortOrder
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getLesson = /* GraphQL */ `
  query GetLesson($id: ID!) {
    getLesson(id: $id) {
      id
      courseID
      moduleID
      title
      slug
      description
      previewVideoUrl
      previewVideoProvider
      videoUrl
      videoProvider
      videoParts
      captionUrl
      captionLabel
      thumbnailUrl
      durationMinutes
      isFreePreview
      isFeatured
      status
      sortOrder
      createdAt
      updatedAt
    }
  }
`;
export const listLessons = /* GraphQL */ `
  query ListLessons(
    $filter: ModelLessonFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listLessons(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        courseID
        moduleID
        title
        slug
        description
        previewVideoUrl
        previewVideoProvider
        videoUrl
        videoProvider
        videoParts
        captionUrl
        captionLabel
        thumbnailUrl
        durationMinutes
        isFreePreview
        isFeatured
        status
        sortOrder
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getLessonView = /* GraphQL */ `
  query GetLessonView($id: ID!) {
    getLessonView(id: $id) {
      id
      lessonID
      viewerKey
      viewedAt
      createdAt
      updatedAt
    }
  }
`;
export const listLessonViews = /* GraphQL */ `
  query ListLessonViews(
    $filter: ModelLessonViewFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listLessonViews(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        lessonID
        viewerKey
        viewedAt
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getLessonComment = /* GraphQL */ `
  query GetLessonComment($id: ID!) {
    getLessonComment(id: $id) {
      id
      lessonID
      courseID
      userID
      parentCommentID
      displayName
      body
      createdAt
      updatedAt
      owner
    }
  }
`;
export const listLessonComments = /* GraphQL */ `
  query ListLessonComments(
    $filter: ModelLessonCommentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listLessonComments(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        lessonID
        courseID
        userID
        parentCommentID
        displayName
        body
        createdAt
        updatedAt
        owner
      }
      nextToken
    }
  }
`;
export const getLessonCommentLike = /* GraphQL */ `
  query GetLessonCommentLike($id: ID!) {
    getLessonCommentLike(id: $id) {
      id
      lessonID
      commentID
      userID
      createdAt
      updatedAt
      owner
    }
  }
`;
export const listLessonCommentLikes = /* GraphQL */ `
  query ListLessonCommentLikes(
    $filter: ModelLessonCommentLikeFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listLessonCommentLikes(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        lessonID
        commentID
        userID
        createdAt
        updatedAt
        owner
      }
      nextToken
    }
  }
`;
export const getLessonCommentReport = /* GraphQL */ `
  query GetLessonCommentReport($id: ID!) {
    getLessonCommentReport(id: $id) {
      id
      lessonID
      commentID
      reason
      details
      resolved
      createdAt
      updatedAt
      owner
    }
  }
`;
export const listLessonCommentReports = /* GraphQL */ `
  query ListLessonCommentReports(
    $filter: ModelLessonCommentReportFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listLessonCommentReports(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        lessonID
        commentID
        reason
        details
        resolved
        createdAt
        updatedAt
        owner
      }
      nextToken
    }
  }
`;
export const getLessonProgress = /* GraphQL */ `
  query GetLessonProgress($id: ID!) {
    getLessonProgress(id: $id) {
      id
      userID
      courseID
      lessonID
      playedSeconds
      videoIndex
      percentComplete
      completed
      lastWatchedAt
      createdAt
      updatedAt
      owner
    }
  }
`;
export const listLessonProgresses = /* GraphQL */ `
  query ListLessonProgresses(
    $filter: ModelLessonProgressFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listLessonProgresses(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        userID
        courseID
        lessonID
        playedSeconds
        videoIndex
        percentComplete
        completed
        lastWatchedAt
        createdAt
        updatedAt
        owner
      }
      nextToken
    }
  }
`;
export const getVibePointTransaction = /* GraphQL */ `
  query GetVibePointTransaction($id: ID!) {
    getVibePointTransaction(id: $id) {
      id
      userID
      sourceType
      sourceID
      title
      description
      points
      earnedAt
      createdAt
      updatedAt
      owner
    }
  }
`;
export const listVibePointTransactions = /* GraphQL */ `
  query ListVibePointTransactions(
    $filter: ModelVibePointTransactionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listVibePointTransactions(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        userID
        sourceType
        sourceID
        title
        description
        points
        earnedAt
        createdAt
        updatedAt
        owner
      }
      nextToken
    }
  }
`;
export const getUserNotification = /* GraphQL */ `
  query GetUserNotification($id: ID!) {
    getUserNotification(id: $id) {
      id
      userID
      type
      title
      body
      link
      isRead
      createdAt
      updatedAt
    }
  }
`;
export const listUserNotifications = /* GraphQL */ `
  query ListUserNotifications(
    $filter: ModelUserNotificationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUserNotifications(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        userID
        type
        title
        body
        link
        isRead
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getStudentVideo = /* GraphQL */ `
  query GetStudentVideo($id: ID!) {
    getStudentVideo(id: $id) {
      id
      userID
      displayName
      profileImageKey
      videoKey
      videoMimeType
      thumbnailKey
      optimizedVideoKey
      hlsManifestKey
      transcodingStatus
      transcodingJobID
      transcodingError
      lessonID
      lessonTitle
      courseID
      courseTitle
      danceType
      caption
      status
      createdAt
      updatedAt
      owner
    }
  }
`;
export const listStudentVideos = /* GraphQL */ `
  query ListStudentVideos(
    $filter: ModelStudentVideoFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listStudentVideos(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        userID
        displayName
        profileImageKey
        videoKey
        videoMimeType
        thumbnailKey
        optimizedVideoKey
        hlsManifestKey
        transcodingStatus
        transcodingJobID
        transcodingError
        lessonID
        lessonTitle
        courseID
        courseTitle
        danceType
        caption
        status
        createdAt
        updatedAt
        owner
      }
      nextToken
    }
  }
`;
export const getStudentVideoLike = /* GraphQL */ `
  query GetStudentVideoLike($id: ID!) {
    getStudentVideoLike(id: $id) {
      id
      videoID
      userID
      createdAt
      updatedAt
      owner
    }
  }
`;
export const listStudentVideoLikes = /* GraphQL */ `
  query ListStudentVideoLikes(
    $filter: ModelStudentVideoLikeFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listStudentVideoLikes(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        videoID
        userID
        createdAt
        updatedAt
        owner
      }
      nextToken
    }
  }
`;
export const getStudentVideoComment = /* GraphQL */ `
  query GetStudentVideoComment($id: ID!) {
    getStudentVideoComment(id: $id) {
      id
      videoID
      userID
      parentCommentID
      displayName
      profileImageKey
      body
      createdAt
      updatedAt
      owner
    }
  }
`;
export const listStudentVideoComments = /* GraphQL */ `
  query ListStudentVideoComments(
    $filter: ModelStudentVideoCommentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listStudentVideoComments(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        videoID
        userID
        parentCommentID
        displayName
        profileImageKey
        body
        createdAt
        updatedAt
        owner
      }
      nextToken
    }
  }
`;
export const getStudentPublicProfile = /* GraphQL */ `
  query GetStudentPublicProfile($id: ID!) {
    getStudentPublicProfile(id: $id) {
      id
      userID
      username
      displayName
      profileImageKey
      bio
      city
      danceLevel
      favoriteStyles
      joinedAt
      updatedAt
      createdAt
      owner
    }
  }
`;
export const listStudentPublicProfiles = /* GraphQL */ `
  query ListStudentPublicProfiles(
    $filter: ModelStudentPublicProfileFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listStudentPublicProfiles(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        userID
        username
        displayName
        profileImageKey
        bio
        city
        danceLevel
        favoriteStyles
        joinedAt
        updatedAt
        createdAt
        owner
      }
      nextToken
    }
  }
`;
export const getStudentFollow = /* GraphQL */ `
  query GetStudentFollow($id: ID!) {
    getStudentFollow(id: $id) {
      id
      followerID
      followingID
      createdAt
      updatedAt
      owner
    }
  }
`;
export const listStudentFollows = /* GraphQL */ `
  query ListStudentFollows(
    $filter: ModelStudentFollowFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listStudentFollows(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        followerID
        followingID
        createdAt
        updatedAt
        owner
      }
      nextToken
    }
  }
`;
export const getStudentVideoBookmark = /* GraphQL */ `
  query GetStudentVideoBookmark($id: ID!) {
    getStudentVideoBookmark(id: $id) {
      id
      videoID
      userID
      createdAt
      updatedAt
      owner
    }
  }
`;
export const listStudentVideoBookmarks = /* GraphQL */ `
  query ListStudentVideoBookmarks(
    $filter: ModelStudentVideoBookmarkFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listStudentVideoBookmarks(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        videoID
        userID
        createdAt
        updatedAt
        owner
      }
      nextToken
    }
  }
`;
export const getStudentVideoView = /* GraphQL */ `
  query GetStudentVideoView($id: ID!) {
    getStudentVideoView(id: $id) {
      id
      videoID
      userID
      createdAt
      updatedAt
      owner
    }
  }
`;
export const listStudentVideoViews = /* GraphQL */ `
  query ListStudentVideoViews(
    $filter: ModelStudentVideoViewFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listStudentVideoViews(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        videoID
        userID
        createdAt
        updatedAt
        owner
      }
      nextToken
    }
  }
`;
export const getStudentVideoFeature = /* GraphQL */ `
  query GetStudentVideoFeature($id: ID!) {
    getStudentVideoFeature(id: $id) {
      id
      videoID
      label
      startsAt
      endsAt
      createdAt
      updatedAt
    }
  }
`;
export const listStudentVideoFeatures = /* GraphQL */ `
  query ListStudentVideoFeatures(
    $filter: ModelStudentVideoFeatureFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listStudentVideoFeatures(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        videoID
        label
        startsAt
        endsAt
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getStudentModerationAction = /* GraphQL */ `
  query GetStudentModerationAction($id: ID!) {
    getStudentModerationAction(id: $id) {
      id
      userID
      action
      reason
      active
      expiresAt
      createdAt
      updatedAt
    }
  }
`;
export const listStudentModerationActions = /* GraphQL */ `
  query ListStudentModerationActions(
    $filter: ModelStudentModerationActionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listStudentModerationActions(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        userID
        action
        reason
        active
        expiresAt
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getStudentVideoReport = /* GraphQL */ `
  query GetStudentVideoReport($id: ID!) {
    getStudentVideoReport(id: $id) {
      id
      videoID
      userID
      reason
      details
      resolved
      createdAt
      updatedAt
      owner
    }
  }
`;
export const listStudentVideoReports = /* GraphQL */ `
  query ListStudentVideoReports(
    $filter: ModelStudentVideoReportFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listStudentVideoReports(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        videoID
        userID
        reason
        details
        resolved
        createdAt
        updatedAt
        owner
      }
      nextToken
    }
  }
`;
export const getJourneyTrack = /* GraphQL */ `
  query GetJourneyTrack($id: ID!) {
    getJourneyTrack(id: $id) {
      id
      title
      slug
      description
      coverImageUrl
      status
      sortOrder
      createdAt
      updatedAt
    }
  }
`;
export const listJourneyTracks = /* GraphQL */ `
  query ListJourneyTracks(
    $filter: ModelJourneyTrackFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listJourneyTracks(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        title
        slug
        description
        coverImageUrl
        status
        sortOrder
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getJourneyUnit = /* GraphQL */ `
  query GetJourneyUnit($id: ID!) {
    getJourneyUnit(id: $id) {
      id
      journeyID
      title
      description
      theme
      status
      sortOrder
      createdAt
      updatedAt
    }
  }
`;
export const listJourneyUnits = /* GraphQL */ `
  query ListJourneyUnits(
    $filter: ModelJourneyUnitFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listJourneyUnits(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        journeyID
        title
        description
        theme
        status
        sortOrder
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getJourneyNode = /* GraphQL */ `
  query GetJourneyNode($id: ID!) {
    getJourneyNode(id: $id) {
      id
      journeyID
      unitID
      lessonID
      journeyLessonID
      title
      slug
      nodeType
      description
      cultureContent
      vpReward
      status
      sortOrder
      createdAt
      updatedAt
    }
  }
`;
export const listJourneyNodes = /* GraphQL */ `
  query ListJourneyNodes(
    $filter: ModelJourneyNodeFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listJourneyNodes(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        journeyID
        unitID
        lessonID
        journeyLessonID
        title
        slug
        nodeType
        description
        cultureContent
        vpReward
        status
        sortOrder
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getJourneyLesson = /* GraphQL */ `
  query GetJourneyLesson($id: ID!) {
    getJourneyLesson(id: $id) {
      id
      journeyID
      unitID
      title
      slug
      description
      videoUrl
      videoProvider
      thumbnailUrl
      durationMinutes
      passingScore
      vpReward
      status
      sortOrder
      createdAt
      updatedAt
    }
  }
`;
export const listJourneyLessons = /* GraphQL */ `
  query ListJourneyLessons(
    $filter: ModelJourneyLessonFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listJourneyLessons(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        journeyID
        unitID
        title
        slug
        description
        videoUrl
        videoProvider
        thumbnailUrl
        durationMinutes
        passingScore
        vpReward
        status
        sortOrder
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getJourneyQuizQuestion = /* GraphQL */ `
  query GetJourneyQuizQuestion($id: ID!) {
    getJourneyQuizQuestion(id: $id) {
      id
      journeyLessonID
      prompt
      options
      correctOption
      explanation
      sortOrder
      createdAt
      updatedAt
    }
  }
`;
export const listJourneyQuizQuestions = /* GraphQL */ `
  query ListJourneyQuizQuestions(
    $filter: ModelJourneyQuizQuestionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listJourneyQuizQuestions(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        journeyLessonID
        prompt
        options
        correctOption
        explanation
        sortOrder
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getJourneyNodeProgress = /* GraphQL */ `
  query GetJourneyNodeProgress($id: ID!) {
    getJourneyNodeProgress(id: $id) {
      id
      userID
      journeyID
      journeyNodeID
      completed
      earnedVP
      completedAt
      createdAt
      updatedAt
      owner
    }
  }
`;
export const listJourneyNodeProgresses = /* GraphQL */ `
  query ListJourneyNodeProgresses(
    $filter: ModelJourneyNodeProgressFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listJourneyNodeProgresses(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        userID
        journeyID
        journeyNodeID
        completed
        earnedVP
        completedAt
        createdAt
        updatedAt
        owner
      }
      nextToken
    }
  }
`;
export const getDanceChallenge = /* GraphQL */ `
  query GetDanceChallenge($id: ID!) {
    getDanceChallenge(id: $id) {
      id
      title
      slug
      description
      rules
      coverImageUrl
      demoVideoUrl
      startAt
      submissionEndsAt
      votingEndsAt
      participationPoints
      winnerPoints
      runnerUpPoints
      thirdPlacePoints
      quizTitle
      quizDescription
      quizPassingScore
      quizPoints
      status
      createdAt
      updatedAt
    }
  }
`;
export const listDanceChallenges = /* GraphQL */ `
  query ListDanceChallenges(
    $filter: ModelDanceChallengeFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listDanceChallenges(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        title
        slug
        description
        rules
        coverImageUrl
        demoVideoUrl
        startAt
        submissionEndsAt
        votingEndsAt
        participationPoints
        winnerPoints
        runnerUpPoints
        thirdPlacePoints
        quizTitle
        quizDescription
        quizPassingScore
        quizPoints
        status
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getChallengeQuiz = /* GraphQL */ `
  query GetChallengeQuiz($id: ID!) {
    getChallengeQuiz(id: $id) {
      id
      challengeID
      title
      description
      coverImageUrl
      mediaType
      mediaUrl
      mediaCaption
      passingScore
      points
      status
      sortOrder
      createdAt
      updatedAt
    }
  }
`;
export const listChallengeQuizs = /* GraphQL */ `
  query ListChallengeQuizs(
    $filter: ModelChallengeQuizFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listChallengeQuizs(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        challengeID
        title
        description
        coverImageUrl
        mediaType
        mediaUrl
        mediaCaption
        passingScore
        points
        status
        sortOrder
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getChallengeQuizLibrarySettings = /* GraphQL */ `
  query GetChallengeQuizLibrarySettings($id: ID!) {
    getChallengeQuizLibrarySettings(id: $id) {
      id
      title
      description
      createdAt
      updatedAt
    }
  }
`;
export const listChallengeQuizLibrarySettings = /* GraphQL */ `
  query ListChallengeQuizLibrarySettings(
    $filter: ModelChallengeQuizLibrarySettingsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listChallengeQuizLibrarySettings(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        title
        description
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getChallengeQuizQuestion = /* GraphQL */ `
  query GetChallengeQuizQuestion($id: ID!) {
    getChallengeQuizQuestion(id: $id) {
      id
      challengeID
      quizID
      prompt
      options
      correctOption
      explanation
      mediaType
      mediaUrl
      mediaCaption
      sortOrder
      createdAt
      updatedAt
    }
  }
`;
export const listChallengeQuizQuestions = /* GraphQL */ `
  query ListChallengeQuizQuestions(
    $filter: ModelChallengeQuizQuestionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listChallengeQuizQuestions(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        challengeID
        quizID
        prompt
        options
        correctOption
        explanation
        mediaType
        mediaUrl
        mediaCaption
        sortOrder
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getChallengeQuizAttempt = /* GraphQL */ `
  query GetChallengeQuizAttempt($id: ID!) {
    getChallengeQuizAttempt(id: $id) {
      id
      challengeID
      quizID
      roundKey
      userID
      displayName
      profileImageKey
      answers
      score
      totalQuestions
      passed
      earnedPoints
      completedAt
      createdAt
      updatedAt
      owner
    }
  }
`;
export const listChallengeQuizAttempts = /* GraphQL */ `
  query ListChallengeQuizAttempts(
    $filter: ModelChallengeQuizAttemptFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listChallengeQuizAttempts(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        challengeID
        quizID
        roundKey
        userID
        displayName
        profileImageKey
        answers
        score
        totalQuestions
        passed
        earnedPoints
        completedAt
        createdAt
        updatedAt
        owner
      }
      nextToken
    }
  }
`;
export const getChallengeSubmission = /* GraphQL */ `
  query GetChallengeSubmission($id: ID!) {
    getChallengeSubmission(id: $id) {
      id
      challengeID
      roundKey
      userID
      displayName
      profileImageKey
      videoKey
      videoMimeType
      caption
      status
      createdAt
      updatedAt
      owner
    }
  }
`;
export const listChallengeSubmissions = /* GraphQL */ `
  query ListChallengeSubmissions(
    $filter: ModelChallengeSubmissionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listChallengeSubmissions(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        challengeID
        roundKey
        userID
        displayName
        profileImageKey
        videoKey
        videoMimeType
        caption
        status
        createdAt
        updatedAt
        owner
      }
      nextToken
    }
  }
`;
export const getChallengeLike = /* GraphQL */ `
  query GetChallengeLike($id: ID!) {
    getChallengeLike(id: $id) {
      id
      challengeID
      submissionID
      createdAt
      updatedAt
      owner
    }
  }
`;
export const listChallengeLikes = /* GraphQL */ `
  query ListChallengeLikes(
    $filter: ModelChallengeLikeFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listChallengeLikes(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        challengeID
        submissionID
        createdAt
        updatedAt
        owner
      }
      nextToken
    }
  }
`;
export const getChallengeView = /* GraphQL */ `
  query GetChallengeView($id: ID!) {
    getChallengeView(id: $id) {
      id
      challengeID
      submissionID
      createdAt
      updatedAt
      owner
    }
  }
`;
export const listChallengeViews = /* GraphQL */ `
  query ListChallengeViews(
    $filter: ModelChallengeViewFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listChallengeViews(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        challengeID
        submissionID
        createdAt
        updatedAt
        owner
      }
      nextToken
    }
  }
`;
export const getChallengeReport = /* GraphQL */ `
  query GetChallengeReport($id: ID!) {
    getChallengeReport(id: $id) {
      id
      challengeID
      submissionID
      reason
      details
      resolved
      createdAt
      updatedAt
      owner
    }
  }
`;
export const listChallengeReports = /* GraphQL */ `
  query ListChallengeReports(
    $filter: ModelChallengeReportFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listChallengeReports(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        challengeID
        submissionID
        reason
        details
        resolved
        createdAt
        updatedAt
        owner
      }
      nextToken
    }
  }
`;
export const memberAccessByUser = /* GraphQL */ `
  query MemberAccessByUser(
    $userID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelMemberAccessFilterInput
    $limit: Int
    $nextToken: String
  ) {
    memberAccessByUser(
      userID: $userID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        userID
        status
        scope
        startsAt
        expiresAt
        reason
        grantedBy
        grantedAt
        revokedAt
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const showSeriesBySlug = /* GraphQL */ `
  query ShowSeriesBySlug(
    $slug: String!
    $sortDirection: ModelSortDirection
    $filter: ModelShowSeriesFilterInput
    $limit: Int
    $nextToken: String
  ) {
    showSeriesBySlug(
      slug: $slug
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        title
        slug
        description
        coverImageUrl
        bannerImageUrl
        category
        externalUrl
        externalLinkLabel
        isFeatured
        status
        sortOrder
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const showEpisodesBySeries = /* GraphQL */ `
  query ShowEpisodesBySeries(
    $seriesID: ID!
    $sortOrder: ModelIntKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelShowEpisodeFilterInput
    $limit: Int
    $nextToken: String
  ) {
    showEpisodesBySeries(
      seriesID: $seriesID
      sortOrder: $sortOrder
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        seriesID
        title
        description
        videoUrl
        videoProvider
        thumbnailUrl
        seasonNumber
        episodeNumber
        durationLabel
        releaseDate
        status
        sortOrder
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const instructorsBySlug = /* GraphQL */ `
  query InstructorsBySlug(
    $slug: String!
    $sortDirection: ModelSortDirection
    $filter: ModelInstructorFilterInput
    $limit: Int
    $nextToken: String
  ) {
    instructorsBySlug(
      slug: $slug
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        slug
        bio
        country
        styles
        profileImageUrl
        headerImageUrl
        instagramUrl
        youtubeUrl
        websiteUrl
        isFeatured
        status
        sortOrder
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const coursesBySlug = /* GraphQL */ `
  query CoursesBySlug(
    $slug: String!
    $sortDirection: ModelSortDirection
    $filter: ModelCourseFilterInput
    $limit: Int
    $nextToken: String
  ) {
    coursesBySlug(
      slug: $slug
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        title
        slug
        shortDescription
        description
        coverImageUrl
        trailerUrl
        difficulty
        accessLevel
        tags
        instructorIDs
        isFeatured
        status
        sortOrder
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const modulesByCourse = /* GraphQL */ `
  query ModulesByCourse(
    $courseID: ID!
    $sortOrder: ModelIntKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelCourseModuleFilterInput
    $limit: Int
    $nextToken: String
  ) {
    modulesByCourse(
      courseID: $courseID
      sortOrder: $sortOrder
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        courseID
        title
        description
        status
        sortOrder
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const lessonsByCourse = /* GraphQL */ `
  query LessonsByCourse(
    $courseID: ID!
    $sortOrder: ModelIntKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelLessonFilterInput
    $limit: Int
    $nextToken: String
  ) {
    lessonsByCourse(
      courseID: $courseID
      sortOrder: $sortOrder
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        courseID
        moduleID
        title
        slug
        description
        previewVideoUrl
        previewVideoProvider
        videoUrl
        videoProvider
        videoParts
        captionUrl
        captionLabel
        thumbnailUrl
        durationMinutes
        isFreePreview
        isFeatured
        status
        sortOrder
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const lessonsByModule = /* GraphQL */ `
  query LessonsByModule(
    $moduleID: ID!
    $sortOrder: ModelIntKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelLessonFilterInput
    $limit: Int
    $nextToken: String
  ) {
    lessonsByModule(
      moduleID: $moduleID
      sortOrder: $sortOrder
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        courseID
        moduleID
        title
        slug
        description
        previewVideoUrl
        previewVideoProvider
        videoUrl
        videoProvider
        videoParts
        captionUrl
        captionLabel
        thumbnailUrl
        durationMinutes
        isFreePreview
        isFeatured
        status
        sortOrder
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const lessonsBySlug = /* GraphQL */ `
  query LessonsBySlug(
    $slug: String!
    $sortDirection: ModelSortDirection
    $filter: ModelLessonFilterInput
    $limit: Int
    $nextToken: String
  ) {
    lessonsBySlug(
      slug: $slug
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        courseID
        moduleID
        title
        slug
        description
        previewVideoUrl
        previewVideoProvider
        videoUrl
        videoProvider
        videoParts
        captionUrl
        captionLabel
        thumbnailUrl
        durationMinutes
        isFreePreview
        isFeatured
        status
        sortOrder
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const viewsByLesson = /* GraphQL */ `
  query ViewsByLesson(
    $lessonID: ID!
    $viewedAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelLessonViewFilterInput
    $limit: Int
    $nextToken: String
  ) {
    viewsByLesson(
      lessonID: $lessonID
      viewedAt: $viewedAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        lessonID
        viewerKey
        viewedAt
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const commentsByLesson = /* GraphQL */ `
  query CommentsByLesson(
    $lessonID: ID!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelLessonCommentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    commentsByLesson(
      lessonID: $lessonID
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        lessonID
        courseID
        userID
        parentCommentID
        displayName
        body
        createdAt
        updatedAt
        owner
      }
      nextToken
    }
  }
`;
export const commentLikesByLesson = /* GraphQL */ `
  query CommentLikesByLesson(
    $lessonID: ID!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelLessonCommentLikeFilterInput
    $limit: Int
    $nextToken: String
  ) {
    commentLikesByLesson(
      lessonID: $lessonID
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        lessonID
        commentID
        userID
        createdAt
        updatedAt
        owner
      }
      nextToken
    }
  }
`;
export const commentLikesByComment = /* GraphQL */ `
  query CommentLikesByComment(
    $commentID: ID!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelLessonCommentLikeFilterInput
    $limit: Int
    $nextToken: String
  ) {
    commentLikesByComment(
      commentID: $commentID
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        lessonID
        commentID
        userID
        createdAt
        updatedAt
        owner
      }
      nextToken
    }
  }
`;
export const commentReportsByComment = /* GraphQL */ `
  query CommentReportsByComment(
    $commentID: ID!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelLessonCommentReportFilterInput
    $limit: Int
    $nextToken: String
  ) {
    commentReportsByComment(
      commentID: $commentID
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        lessonID
        commentID
        reason
        details
        resolved
        createdAt
        updatedAt
        owner
      }
      nextToken
    }
  }
`;
export const progressByUser = /* GraphQL */ `
  query ProgressByUser(
    $userID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelLessonProgressFilterInput
    $limit: Int
    $nextToken: String
  ) {
    progressByUser(
      userID: $userID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        userID
        courseID
        lessonID
        playedSeconds
        videoIndex
        percentComplete
        completed
        lastWatchedAt
        createdAt
        updatedAt
        owner
      }
      nextToken
    }
  }
`;
export const progressByLesson = /* GraphQL */ `
  query ProgressByLesson(
    $lessonID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelLessonProgressFilterInput
    $limit: Int
    $nextToken: String
  ) {
    progressByLesson(
      lessonID: $lessonID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        userID
        courseID
        lessonID
        playedSeconds
        videoIndex
        percentComplete
        completed
        lastWatchedAt
        createdAt
        updatedAt
        owner
      }
      nextToken
    }
  }
`;
export const vibePointsByUser = /* GraphQL */ `
  query VibePointsByUser(
    $userID: ID!
    $earnedAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelVibePointTransactionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    vibePointsByUser(
      userID: $userID
      earnedAt: $earnedAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        userID
        sourceType
        sourceID
        title
        description
        points
        earnedAt
        createdAt
        updatedAt
        owner
      }
      nextToken
    }
  }
`;
export const notificationsByUser = /* GraphQL */ `
  query NotificationsByUser(
    $userID: ID!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelUserNotificationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    notificationsByUser(
      userID: $userID
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        userID
        type
        title
        body
        link
        isRead
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const studentVideosByUser = /* GraphQL */ `
  query StudentVideosByUser(
    $userID: ID!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelStudentVideoFilterInput
    $limit: Int
    $nextToken: String
  ) {
    studentVideosByUser(
      userID: $userID
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        userID
        displayName
        profileImageKey
        videoKey
        videoMimeType
        thumbnailKey
        optimizedVideoKey
        hlsManifestKey
        transcodingStatus
        transcodingJobID
        transcodingError
        lessonID
        lessonTitle
        courseID
        courseTitle
        danceType
        caption
        status
        createdAt
        updatedAt
        owner
      }
      nextToken
    }
  }
`;
export const studentLikesByVideo = /* GraphQL */ `
  query StudentLikesByVideo(
    $videoID: ID!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelStudentVideoLikeFilterInput
    $limit: Int
    $nextToken: String
  ) {
    studentLikesByVideo(
      videoID: $videoID
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        videoID
        userID
        createdAt
        updatedAt
        owner
      }
      nextToken
    }
  }
`;
export const studentCommentsByVideo = /* GraphQL */ `
  query StudentCommentsByVideo(
    $videoID: ID!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelStudentVideoCommentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    studentCommentsByVideo(
      videoID: $videoID
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        videoID
        userID
        parentCommentID
        displayName
        profileImageKey
        body
        createdAt
        updatedAt
        owner
      }
      nextToken
    }
  }
`;
export const studentProfilesByUser = /* GraphQL */ `
  query StudentProfilesByUser(
    $userID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelStudentPublicProfileFilterInput
    $limit: Int
    $nextToken: String
  ) {
    studentProfilesByUser(
      userID: $userID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        userID
        username
        displayName
        profileImageKey
        bio
        city
        danceLevel
        favoriteStyles
        joinedAt
        updatedAt
        createdAt
        owner
      }
      nextToken
    }
  }
`;
export const studentFollowsByFollower = /* GraphQL */ `
  query StudentFollowsByFollower(
    $followerID: ID!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelStudentFollowFilterInput
    $limit: Int
    $nextToken: String
  ) {
    studentFollowsByFollower(
      followerID: $followerID
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        followerID
        followingID
        createdAt
        updatedAt
        owner
      }
      nextToken
    }
  }
`;
export const studentFollowersByFollowing = /* GraphQL */ `
  query StudentFollowersByFollowing(
    $followingID: ID!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelStudentFollowFilterInput
    $limit: Int
    $nextToken: String
  ) {
    studentFollowersByFollowing(
      followingID: $followingID
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        followerID
        followingID
        createdAt
        updatedAt
        owner
      }
      nextToken
    }
  }
`;
export const studentBookmarksByVideo = /* GraphQL */ `
  query StudentBookmarksByVideo(
    $videoID: ID!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelStudentVideoBookmarkFilterInput
    $limit: Int
    $nextToken: String
  ) {
    studentBookmarksByVideo(
      videoID: $videoID
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        videoID
        userID
        createdAt
        updatedAt
        owner
      }
      nextToken
    }
  }
`;
export const studentBookmarksByUser = /* GraphQL */ `
  query StudentBookmarksByUser(
    $userID: ID!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelStudentVideoBookmarkFilterInput
    $limit: Int
    $nextToken: String
  ) {
    studentBookmarksByUser(
      userID: $userID
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        videoID
        userID
        createdAt
        updatedAt
        owner
      }
      nextToken
    }
  }
`;
export const studentViewsByVideo = /* GraphQL */ `
  query StudentViewsByVideo(
    $videoID: ID!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelStudentVideoViewFilterInput
    $limit: Int
    $nextToken: String
  ) {
    studentViewsByVideo(
      videoID: $videoID
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        videoID
        userID
        createdAt
        updatedAt
        owner
      }
      nextToken
    }
  }
`;
export const studentFeaturesByVideo = /* GraphQL */ `
  query StudentFeaturesByVideo(
    $videoID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelStudentVideoFeatureFilterInput
    $limit: Int
    $nextToken: String
  ) {
    studentFeaturesByVideo(
      videoID: $videoID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        videoID
        label
        startsAt
        endsAt
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const studentModerationByUser = /* GraphQL */ `
  query StudentModerationByUser(
    $userID: ID!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelStudentModerationActionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    studentModerationByUser(
      userID: $userID
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        userID
        action
        reason
        active
        expiresAt
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const studentReportsByVideo = /* GraphQL */ `
  query StudentReportsByVideo(
    $videoID: ID!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelStudentVideoReportFilterInput
    $limit: Int
    $nextToken: String
  ) {
    studentReportsByVideo(
      videoID: $videoID
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        videoID
        userID
        reason
        details
        resolved
        createdAt
        updatedAt
        owner
      }
      nextToken
    }
  }
`;
export const journeysBySlug = /* GraphQL */ `
  query JourneysBySlug(
    $slug: String!
    $sortDirection: ModelSortDirection
    $filter: ModelJourneyTrackFilterInput
    $limit: Int
    $nextToken: String
  ) {
    journeysBySlug(
      slug: $slug
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        title
        slug
        description
        coverImageUrl
        status
        sortOrder
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const unitsByJourney = /* GraphQL */ `
  query UnitsByJourney(
    $journeyID: ID!
    $sortOrder: ModelIntKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelJourneyUnitFilterInput
    $limit: Int
    $nextToken: String
  ) {
    unitsByJourney(
      journeyID: $journeyID
      sortOrder: $sortOrder
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        journeyID
        title
        description
        theme
        status
        sortOrder
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const nodesByJourney = /* GraphQL */ `
  query NodesByJourney(
    $journeyID: ID!
    $sortOrder: ModelIntKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelJourneyNodeFilterInput
    $limit: Int
    $nextToken: String
  ) {
    nodesByJourney(
      journeyID: $journeyID
      sortOrder: $sortOrder
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        journeyID
        unitID
        lessonID
        journeyLessonID
        title
        slug
        nodeType
        description
        cultureContent
        vpReward
        status
        sortOrder
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const nodesByUnit = /* GraphQL */ `
  query NodesByUnit(
    $unitID: ID!
    $sortOrder: ModelIntKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelJourneyNodeFilterInput
    $limit: Int
    $nextToken: String
  ) {
    nodesByUnit(
      unitID: $unitID
      sortOrder: $sortOrder
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        journeyID
        unitID
        lessonID
        journeyLessonID
        title
        slug
        nodeType
        description
        cultureContent
        vpReward
        status
        sortOrder
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const journeyNodesBySlug = /* GraphQL */ `
  query JourneyNodesBySlug(
    $slug: String!
    $sortDirection: ModelSortDirection
    $filter: ModelJourneyNodeFilterInput
    $limit: Int
    $nextToken: String
  ) {
    journeyNodesBySlug(
      slug: $slug
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        journeyID
        unitID
        lessonID
        journeyLessonID
        title
        slug
        nodeType
        description
        cultureContent
        vpReward
        status
        sortOrder
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const journeyLessonsByJourney = /* GraphQL */ `
  query JourneyLessonsByJourney(
    $journeyID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelJourneyLessonFilterInput
    $limit: Int
    $nextToken: String
  ) {
    journeyLessonsByJourney(
      journeyID: $journeyID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        journeyID
        unitID
        title
        slug
        description
        videoUrl
        videoProvider
        thumbnailUrl
        durationMinutes
        passingScore
        vpReward
        status
        sortOrder
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const journeyLessonsByUnit = /* GraphQL */ `
  query JourneyLessonsByUnit(
    $unitID: ID!
    $sortOrder: ModelIntKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelJourneyLessonFilterInput
    $limit: Int
    $nextToken: String
  ) {
    journeyLessonsByUnit(
      unitID: $unitID
      sortOrder: $sortOrder
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        journeyID
        unitID
        title
        slug
        description
        videoUrl
        videoProvider
        thumbnailUrl
        durationMinutes
        passingScore
        vpReward
        status
        sortOrder
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const journeyLessonsBySlug = /* GraphQL */ `
  query JourneyLessonsBySlug(
    $slug: String!
    $sortDirection: ModelSortDirection
    $filter: ModelJourneyLessonFilterInput
    $limit: Int
    $nextToken: String
  ) {
    journeyLessonsBySlug(
      slug: $slug
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        journeyID
        unitID
        title
        slug
        description
        videoUrl
        videoProvider
        thumbnailUrl
        durationMinutes
        passingScore
        vpReward
        status
        sortOrder
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const quizQuestionsByJourneyLesson = /* GraphQL */ `
  query QuizQuestionsByJourneyLesson(
    $journeyLessonID: ID!
    $sortOrder: ModelIntKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelJourneyQuizQuestionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    quizQuestionsByJourneyLesson(
      journeyLessonID: $journeyLessonID
      sortOrder: $sortOrder
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        journeyLessonID
        prompt
        options
        correctOption
        explanation
        sortOrder
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const journeyProgressByUser = /* GraphQL */ `
  query JourneyProgressByUser(
    $userID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelJourneyNodeProgressFilterInput
    $limit: Int
    $nextToken: String
  ) {
    journeyProgressByUser(
      userID: $userID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        userID
        journeyID
        journeyNodeID
        completed
        earnedVP
        completedAt
        createdAt
        updatedAt
        owner
      }
      nextToken
    }
  }
`;
export const journeyProgressByNode = /* GraphQL */ `
  query JourneyProgressByNode(
    $journeyNodeID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelJourneyNodeProgressFilterInput
    $limit: Int
    $nextToken: String
  ) {
    journeyProgressByNode(
      journeyNodeID: $journeyNodeID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        userID
        journeyID
        journeyNodeID
        completed
        earnedVP
        completedAt
        createdAt
        updatedAt
        owner
      }
      nextToken
    }
  }
`;
export const challengesBySlug = /* GraphQL */ `
  query ChallengesBySlug(
    $slug: String!
    $sortDirection: ModelSortDirection
    $filter: ModelDanceChallengeFilterInput
    $limit: Int
    $nextToken: String
  ) {
    challengesBySlug(
      slug: $slug
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        title
        slug
        description
        rules
        coverImageUrl
        demoVideoUrl
        startAt
        submissionEndsAt
        votingEndsAt
        participationPoints
        winnerPoints
        runnerUpPoints
        thirdPlacePoints
        quizTitle
        quizDescription
        quizPassingScore
        quizPoints
        status
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const quizzesByChallenge = /* GraphQL */ `
  query QuizzesByChallenge(
    $challengeID: ID!
    $sortOrder: ModelIntKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelChallengeQuizFilterInput
    $limit: Int
    $nextToken: String
  ) {
    quizzesByChallenge(
      challengeID: $challengeID
      sortOrder: $sortOrder
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        challengeID
        title
        description
        coverImageUrl
        mediaType
        mediaUrl
        mediaCaption
        passingScore
        points
        status
        sortOrder
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const quizQuestionsByChallenge = /* GraphQL */ `
  query QuizQuestionsByChallenge(
    $challengeID: ID!
    $sortOrder: ModelIntKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelChallengeQuizQuestionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    quizQuestionsByChallenge(
      challengeID: $challengeID
      sortOrder: $sortOrder
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        challengeID
        quizID
        prompt
        options
        correctOption
        explanation
        mediaType
        mediaUrl
        mediaCaption
        sortOrder
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const quizQuestionsByQuiz = /* GraphQL */ `
  query QuizQuestionsByQuiz(
    $quizID: ID!
    $sortOrder: ModelIntKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelChallengeQuizQuestionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    quizQuestionsByQuiz(
      quizID: $quizID
      sortOrder: $sortOrder
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        challengeID
        quizID
        prompt
        options
        correctOption
        explanation
        mediaType
        mediaUrl
        mediaCaption
        sortOrder
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const quizAttemptsByChallenge = /* GraphQL */ `
  query QuizAttemptsByChallenge(
    $challengeID: ID!
    $completedAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelChallengeQuizAttemptFilterInput
    $limit: Int
    $nextToken: String
  ) {
    quizAttemptsByChallenge(
      challengeID: $challengeID
      completedAt: $completedAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        challengeID
        quizID
        roundKey
        userID
        displayName
        profileImageKey
        answers
        score
        totalQuestions
        passed
        earnedPoints
        completedAt
        createdAt
        updatedAt
        owner
      }
      nextToken
    }
  }
`;
export const challengeQuizAttemptsByUser = /* GraphQL */ `
  query ChallengeQuizAttemptsByUser(
    $userID: ID!
    $completedAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelChallengeQuizAttemptFilterInput
    $limit: Int
    $nextToken: String
  ) {
    challengeQuizAttemptsByUser(
      userID: $userID
      completedAt: $completedAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        challengeID
        quizID
        roundKey
        userID
        displayName
        profileImageKey
        answers
        score
        totalQuestions
        passed
        earnedPoints
        completedAt
        createdAt
        updatedAt
        owner
      }
      nextToken
    }
  }
`;
export const submissionsByChallenge = /* GraphQL */ `
  query SubmissionsByChallenge(
    $challengeID: ID!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelChallengeSubmissionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    submissionsByChallenge(
      challengeID: $challengeID
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        challengeID
        roundKey
        userID
        displayName
        profileImageKey
        videoKey
        videoMimeType
        caption
        status
        createdAt
        updatedAt
        owner
      }
      nextToken
    }
  }
`;
export const likesBySubmission = /* GraphQL */ `
  query LikesBySubmission(
    $submissionID: ID!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelChallengeLikeFilterInput
    $limit: Int
    $nextToken: String
  ) {
    likesBySubmission(
      submissionID: $submissionID
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        challengeID
        submissionID
        createdAt
        updatedAt
        owner
      }
      nextToken
    }
  }
`;
export const challengeViewsBySubmission = /* GraphQL */ `
  query ChallengeViewsBySubmission(
    $submissionID: ID!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelChallengeViewFilterInput
    $limit: Int
    $nextToken: String
  ) {
    challengeViewsBySubmission(
      submissionID: $submissionID
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        challengeID
        submissionID
        createdAt
        updatedAt
        owner
      }
      nextToken
    }
  }
`;
export const reportsBySubmission = /* GraphQL */ `
  query ReportsBySubmission(
    $submissionID: ID!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelChallengeReportFilterInput
    $limit: Int
    $nextToken: String
  ) {
    reportsBySubmission(
      submissionID: $submissionID
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        challengeID
        submissionID
        reason
        details
        resolved
        createdAt
        updatedAt
        owner
      }
      nextToken
    }
  }
`;
